import React from 'react';

import { graphql, useFragment } from 'react-relay';

import { RequiredAsterisk } from '@atlaskit/form';
import { Text } from '@atlaskit/primitives/compiled';

import type { fieldLabel_AtlassianConversationAssistantPreviewCard$key as FieldConfigKey } from './__generated__/fieldLabel_AtlassianConversationAssistantPreviewCard.graphql';

export const FieldLabel = ({
	fieldConfig,
	fallbackFieldName,
}: {
	fieldConfig?: FieldConfigKey | null;
	fallbackFieldName: string;
}): React.JSX.Element => {
	const fieldConfigData = useFragment<FieldConfigKey>(
		graphql`
			fragment fieldLabel_AtlassianConversationAssistantPreviewCard on JiraIssueField {
				name
				... on JiraIssueFieldConfiguration {
					fieldConfig {
						isRequired
					}
				}
			}
		`,
		fieldConfig ?? null,
	);

	return (
		<Text size="medium" weight="regular" color="color.text.subtlest">
			{toSentenceCase(fieldConfigData?.name ?? fallbackFieldName)}:
			{fieldConfigData?.fieldConfig?.isRequired && <RequiredAsterisk />}
		</Text>
	);
};

function toSentenceCase(str: string) {
	if (!str) {
		return '';
	}
	return str.charAt(0).toUpperCase() + str.slice(1);
}
